import { toolboxApi, unwrapResult } from '~/modules/query/base';

/** GET /customers/stats — a bare customer count. */
export type HomeStats = number;

/** `transactions: true` counts the FinancialBAY customers instead of the ClientBAY ones. */
export interface HomeStatsArgs {
  transactions?: boolean;
}

export const homeApi = toolboxApi.injectEndpoints({
  endpoints: (builder) => ({
    getHomeStats: builder.query<HomeStats, HomeStatsArgs>({
      query: ({ transactions }) => ({
        url: `/customers/stats${transactions ? '?transactions=true' : ''}`,
        method: 'GET',
      }),
      transformResponse: unwrapResult<HomeStats>,
      providesTags: ['Home'],
    }),
  }),
});

export const { useGetHomeStatsQuery } = homeApi;
